/**
 * @file: clientPlatformRefused.ts
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { BehaviorSubject } from 'rxjs';

/**
 * Set when the server refuses this build for the store (the web version or
 * the hub build it has not bought): every request fails then, so the app
 * shows one notice. Cleared at sign-out.
 */
export const clientPlatformRefused$ = new BehaviorSubject<boolean>(false);
